// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema).
// FNP-214: MeterDefinition fields — meterCode (stable code format) + aggregation
// / grain / unit / resetPolicy / purpose / lateness + watermark windows.
import {z} from 'zod';

// Stable code format: lowercase segments separated by dots, e.g. "email.sent",
// "domain.registered". No leading/trailing/double dots, no uppercase, no spaces.
const METER_CODE_PATTERN = /^[a-z0-9]+(\.[a-z0-9]+)*$/;

export const RecordSchema = z.object({
    name: z.string().min(1, 'Required'),
    meterCode: z.string()
        .min(1, 'Required')
        .regex(METER_CODE_PATTERN, 'Lowercase, dot-separated (e.g. email.sent)'),
    aggregation: z.string().min(1, 'Required'),
    grain: z.string().min(1, 'Required'),
    unit: z.string().optional(),
    resetPolicy: z.string().min(1, 'Required'),
    purpose: z.string().min(1, 'Required'),
    latenessWindowMinutes: z.coerce.number().int().nonnegative(),
    watermarkDelayMinutes: z.coerce.number().int().nonnegative(),
    status: z.string().min(1, 'Required'),
    dimensions: z.array(z.object({
        name: z.string().min(1, 'Required'),
    })).optional(),
});
